export default __webpack_public_path__ + "img/play_store_badge.c3c75653.svg";